const styles = {
	components: {
		MuiGrid: {
			styleOverrides: {
				root: {
					'&.gallery__slider': {
						width: '100%',
						'&.gallery__slider--image-first': {
							order: 1,
						},
						'&.gallery__slider--content-first': {
							order: 2,
						},
						'&.gallery__slider--full-width': {
							width: '100%',
						},
					},
					'&.gallery__content': {
						width: '100%',
						'&.gallery__content--image-first': {
							order: 2,
						},
						'&.gallery__content--content-first': {
							order: 1,
						},
						'&.gallery__content--full-width': {
							width: '100%',
						},
					},
				},
			},
		},
		MuiBox: {
			styleOverrides: {
				root: {
					'&.gallery__image-box': {
						borderRadius: '8px',
						overflow: 'hidden',
					},
				},
			},
		},
		MuiImage: {
			styleOverrides: {
				root: {
					display: 'flex',
					justifyContent: 'center',
				},
			},
		},
	},
};

export default styles;